import cn from 'classnames';

import { fromServicesToFlattened } from 'bl/services/calculateServicesPriceAndTimeRanges.bl';
import { useTranslation } from 'providers/GILT.provider';

import CategoryServiceItem from 'booking/components/common/CategoryItem';
import SearchSelectBar from 'booking/components/common/SearchSelectBar';

import CN from './SettingsSearchServices.module.scss';

const SettingsSearchServices = ({ services, onSelect, isSearching, onStartSearching }) => {
  const { t } = useTranslation();

  const flattenedServices = fromServicesToFlattened(services);

  return (
    <div data-bem="SettingsSearchServices">
      <div className={CN.title}>{t('staffAndBusiness.servicePrices.searchServicesTitle')}</div>
      <div className={cn({ [CN.searchBar]: true, [CN.dropdown]: isSearching })}>
        <SearchSelectBar
          options={flattenedServices}
          onSelect={onSelect}
          onStartSearching={onStartSearching}
          placeholder={t('staffAndBusiness.servicePrices.searchSelectPlaceholder', { count: flattenedServices.length })}
        >
          {(value, onSelect) => (
            <CategoryServiceItem
              key={value.id}
              categoryName={value.name}
              color={value.color}
              onAddServiceCategory={() => onSelect(value)}
            />
          )}
        </SearchSelectBar>
      </div>
    </div>
  );
};

export default SettingsSearchServices;
